import { MarketType } from '@/constants';
import { AppError } from '@/errors/appError';

export function parseBotIdList(value: string | number[] | null | undefined): number[] | null {
    if (value == null || value === '') return null;
    if (Array.isArray(value)) return value.length ? value : null;

    const ids = String(value)
        .split(',')
        .map((part) => part.trim())
        .filter(Boolean)
        .map(Number)
        .filter((id) => !Number.isNaN(id));

    return ids.length ? ids : null;
}

export function toBotRangeValue(value: string | number | null | undefined): string | null {
    if (value === null || value === undefined || value === '') return null;
    return String(value);
}

//todo need to refactor and remove this function
export function betTypeIdToMarketTypeId(id: number): MarketType {
    if (id === 1) return MarketType.Handicap;
    if (id === 2) return MarketType.Goal;
    if (id === 3) return MarketType.OneXTwo;
    if (id === 4) return MarketType.Bts;
    if (id === 5) return MarketType.Dc;
    if (id === 6) return MarketType.Cs;
    if (id === 7) return MarketType.CornersHandicap;
    if (id === 8) return MarketType.CornersGoal;
    if (id === 9) return MarketType.GoalHome;
    if (id === 10) return MarketType.GoalAway;
    if (id === 11) return MarketType.DrawNoBet;

    throw new AppError(`${id} is not a valid MarketTypeId`);
}
